import { faBank, faCreditCard } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { PaymentMethodType } from "../../domain/invoicing/payment"

type Props = {
  type: PaymentMethodType
}

const icons: Record<PaymentMethodType, any> = {
  'ach': faBank,
  'validatedAch': faBank,
  'card': faCreditCard,
  'unknown': faCreditCard
}

const PaymentMethodIcon = ({type}: Props) => {
  return <div style={{width: '30px', textAlign: 'center'}}>
    <FontAwesomeIcon icon={icons[type]} size="lg" />
  </div>
}

export default PaymentMethodIcon
